const CART_ICON =
  '<svg width="24" height="24" viewBox="0 0 24 24" class="icon icon--cart" aria-hidden="true" focusable="false" role="presentation"><path fill="currentColor" d="M17 18a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7 2.78-5H6.14l2.36 5H16Z"/></svg>';

if (!customElements.get('complementary-products-tabs')) {
  customElements.define(
    'complementary-products-tabs',
    class ComplementaryProductsTabs extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.cpData = this._loadData();
        if (!this.cpData) return;

        this.i18n = {
          addToCart: this.dataset.i18nAddToCart,
          soldOut: this.dataset.i18nSoldOut,
          qty: this.dataset.i18nQty,
          increaseQty: this.dataset.i18nIncreaseQty,
          decreaseQty: this.dataset.i18nDecreaseQty,
        };

        this._onVariantChange = (event) => {
          const variant = event.detail?.variant;
          if (variant) this._render(variant.id);
        };

        document.addEventListener('on:variant:change', this._onVariantChange);

        // Event delegation for ATC buttons
        this.addEventListener('click', (event) => {
          const atcBtn = event.target.closest('.cp-atc-btn');
          if (atcBtn && !atcBtn.disabled) this._addToCart(atcBtn);
        });

        const initialVariantId = parseInt(this.dataset.currentVariant, 10);
        if (initialVariantId) this._render(initialVariantId);
      }

      disconnectedCallback() {
        if (this._onVariantChange) {
          document.removeEventListener('on:variant:change', this._onVariantChange);
        }
      }

      _loadData() {
        const el = document.getElementById(
          `complementary-products-data-${this.sectionId}`
        );
        if (!el) return null;
        try {
          return JSON.parse(el.textContent);
        } catch (e) {
          console.error('complementary-products: invalid JSON', e);
          return null;
        }
      }

      _render(variantId) {
        const entries = this.cpData[variantId];
        if (!entries || entries.length === 0) {
          this.innerHTML = '';
          this.hidden = true;
          return;
        }

        // Group by tab name, preserving insertion order
        const tabs = new Map();
        for (const entry of entries) {
          const tab = entry.tab || 'Products';
          if (!tabs.has(tab)) tabs.set(tab, []);
          tabs.get(tab).push(entry);
        }

        const tabNames = [...tabs.keys()];
        let html = '<div class="cp-accordions">';

        tabNames.forEach((name, i) => {
          html += `<details class="cp-accordion"${i === 0 ? ' open' : ''}>
            <summary class="cp-accordion__summary">
              <span class="cp-accordion__title">${this._esc(name)}</span>
              <span class="cp-accordion__icon" aria-hidden="true"></span>
            </summary>
            <div class="cp-accordion__panel">
              <ul class="cp-tabs__products">`;
          for (const entry of tabs.get(name)) {
            html += this._cardHtml(entry);
          }
          html += `</ul>
            </div>
          </details>`;
        });

        html += '</div>';
        this.innerHTML = html;
        this.hidden = false;
      }

      _cardHtml(entry) {
        const img = entry.product_image
          ? `<img src="${entry.product_image}" alt="${this._esc(entry.product_title)}" class="cp-card__img" width="80" height="80" loading="lazy">`
          : '<div class="cp-card__img cp-card__img--placeholder"></div>';

        const soldOut = !entry.available;
        const qtyId = `cp-qty-${entry.variant_id}`;

        const optionsHtml =
          entry.options && entry.options.length > 0
            ? `<dl class="cp-card__variants mt-1 mb-1">${entry.options
                .map(
                  (o) =>
                    `<div><dt class="inline"><strong>${this._esc(o.name)}: </strong></dt><dd class="inline m-0">${this._esc(o.value)}</dd></div>`
                )
                .join('')}</dl>`
            : '';

        return `<li class="cp-card" data-variant-id="${entry.variant_id}">
          <a href="${entry.product_url}" class="cp-card__media">${img}</a>
          <div class="cp-card__body">
            <a href="${entry.product_url}" class="cp-card__title">${this._esc(entry.product_title)}</a>
            ${optionsHtml}
            <div class="cp-card__price">${entry.product_price_html}</div>
          </div>
          <div class="cp-card__actions">
            <div class="product-info__add-to-cart flex">
              <quantity-input class="inline-block">
                <label class="label visually-hidden" for="${qtyId}">${this.i18n.qty}</label>
                <div class="qty-input qty-input--combined inline-flex items-center w-full">
                  <button type="button" class="qty-input__btn btn btn--minus no-js-hidden" name="minus" aria-controls="${qtyId}">
                    <span class="visually-hidden">${this.i18n.decreaseQty}</span>
                  </button>
                  <input type="number" class="qty-input__input input" id="${qtyId}" name="quantity" min="1" value="${entry.qty}">
                  <button type="button" class="qty-input__btn btn btn--plus no-js-hidden" name="plus" aria-controls="${qtyId}">
                    <span class="visually-hidden">${this.i18n.increaseQty}</span>
                  </button>
                </div>
              </quantity-input>
              <div class="product-info__add-button">
                <button
                  type="button"
                  class="btn btn--secondary w-full cp-atc-btn"
                  data-variant-id="${entry.variant_id}"
                  ${soldOut ? 'disabled' : ''}
                >${soldOut
                  ? this.i18n.soldOut
                  : `${CART_ICON}<span class="visually-hidden">${this.i18n.addToCart}</span>`
                }</button>
              </div>
            </div>
          </div>
        </li>`;
      }

      _addToCart(btn) {
        const card = btn.closest('.cp-card');
        const variantId = parseInt(btn.dataset.variantId, 10);
        const qty = parseInt(card.querySelector('.qty-input__input').value, 10) || 1;

        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');

        const sections = this.cart?.getSectionsToRender().map((s) => s.section) ?? [];

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: qty }],
            sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              document.dispatchEvent(new CustomEvent('on:cart:error', {
                bubbles: true,
                detail: {
                  source: 'complementary-products',
                  productVariantId: variantId,
                  errors: response.description,
                  message: response.message,
                },
              }));
              return;
            }
            document.dispatchEvent(new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: { cart: response },
            }));
            if (this.cart) {
              this.cart.classList.remove('is-empty');
              this.cart.renderContents(response).catch(() => {});
            }
          })
          .catch(console.error)
          .finally(() => {
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
          });
      }

      _esc(str) {
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }
    }
  );
}
